"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterObjectUndefinedValues = filterObjectUndefinedValues;
exports.sortObjectKeysRecursively = sortObjectKeysRecursively;
const lodash_1 = require("lodash");
function filterObjectUndefinedValues(obj) {
    return Object.fromEntries(Object.entries(obj).filter(([, v]) => v !== undefined));
}
function sortObjectKeysRecursively(obj) {
    if (obj === null || obj === undefined) {
        return obj;
    }
    if (Array.isArray(obj)) {
        return obj.map((item) => sortObjectKeysRecursively(item));
    }
    if ((0, lodash_1.isPlainObject)(obj)) {
        const sortedKeys = Object.keys(obj).sort();
        const sortedObj = {};
        for (const key of sortedKeys) {
            sortedObj[key] = sortObjectKeysRecursively(obj[key]);
        }
        return sortedObj;
    }
    return obj;
}
//# sourceMappingURL=object-utils.js.map